import React, { memo } from 'react';
import PropTypes from 'prop-types';
import ClientComponents from '@components/ClientComponents';
import { Order, Comment } from '@components/Icons';
import Tag, { TAG_TYPE } from '@components/Tag';
import Stars from '@components/Stars';
import Card from './components/Card';
import UserImage from './components/UserImage';
import Body from './components/Body';
import HeaderContent from './components/HeaderContent';
import CardHeader from './components/CardHeader';
import Title from './components/Title';
import Description from './components/Description';
import Status from './components/Status';

function ReviewCard({
  image,
  score,
  name,
  description,
  date,
  orderCount,
  reviewCount,
}) {
  return (
    <Card>
      <UserImage src={image} alt={name} />
      <Body>
        <HeaderContent>
          <CardHeader>
            <Title>{name}</Title>
            <Stars score={score} />
          </CardHeader>
          <ClientComponents>{date}</ClientComponents>
        </HeaderContent>
        <Description>{description}</Description>
        <Status>
          {Boolean(orderCount) && (
            <Tag
              text={orderCount}
              type={TAG_TYPE.DEFAULT}
              icon={<Order size="xsmall" />}
              rounded
            />
          )}
          {Boolean(reviewCount) && (
            <Tag
              text={reviewCount}
              type={TAG_TYPE.DEFAULT}
              icon={<Comment size="xsmall" />}
              rounded
            />
          )}
        </Status>
      </Body>
    </Card>
  );
}

ReviewCard.propTypes = {
  image: PropTypes.string,
  score: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  date: PropTypes.string.isRequired,
  orderCount: PropTypes.number,
  reviewCount: PropTypes.number,
};

export default memo(ReviewCard);
